import React, { useState, useRef, useCallback, useEffect } from 'react';
import { ReactComponent as PlayIcon } from '../../assets/icons/duck.svg';
import { ReactComponent as LearnIcon } from '../../assets/icons/learn.svg';
import { useIsAuthenticated, useAuthUser } from 'react-auth-kit';
import { useNavigate } from 'react-router-dom';
import Hangman from '../Games/Hangman';
import PersonPinIcon from '@mui/icons-material/PersonPin';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { open } from 'fs';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import { deepOrange } from '@mui/material/colors';
import axios from 'axios';
import Appointments from './Appointments';
import { DoctorCheckup, DoctorsOffice, WantToBeDoctor, VirtualFieldTrip } from './Learn';


export default function Profile(props) {
    const isAuthenticated = useIsAuthenticated();
    const auth = useAuthUser();
    const [show, setShow] = useState();
    const [value, setValue] = useState('1'); // value must be set to string or else we'll get invalid value error from mui
    const handleChange = (event, newValue) => {
        setValue(newValue);
    }
    const [user, setUser] = useState([]);
    const [profilePic, setProfilePic] = useState();
    const [file, setFile] = useState();
    const navigate = useNavigate();

    let gamesRef = useRef();
    let learnRef = useRef();
    let fileRef = useRef();

    const handleClick = (props) => {
        if (props.show) {
            // This logic works!!!!
            setShow(true);
        } else {
            setShow(false);
        }
        learnRef.current = props.learn;
        gamesRef.current = props.name;
    };

    let message;


    const GetUser = useCallback(() => {
        if (isAuthenticated()) {
            axios.post('http://localhost:5000/GetUser', { id: auth().id })
                .then((response) => {
                    setUser(response.data);
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    }, [user]);


    const handleFileChange = (event) => {
        setFile(event.target.files[0]);
    }

    const handleFileSubmit = (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append("myfile", file.name);
        formData.append("userId", user._id);
        formData.append("fileName", file.name);
        formData.append("picPath", "./Uploads");

        axios.post("http://localhost:5000/UploadProfilePic", formData)
            .then((response) => {
                if (response.status === 200) {
                    navigate('./');
                }
            })
            .catch((error) => {
                console.log(error);
            })
    }

    const importAll = require =>
        require.keys().reduce((acc, next) => {
            acc[next.replace("./", "")] = require(next);
            return acc;
        }, {});

    const images = require.context('./Uploads', true);
  
    useEffect(() => {
        GetUser();
    });

    useEffect(() => {
        GetUser();
    }, [user]);


    // Mention in evaluation that I was making this far too difficult when I should have just been using the Mui Avatar component.  With this component you can just set the url of the picture and if not found it will show a default mystery man pic automatically.

    return (
        <React.Fragment>


            <main>
                <h1>Profile</h1>

                <Box className="Profile">
                    <TabContext value={value}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <p>Hi {user.username}, welcome to your profile!  We're very happy you're here.  What would you like to do today?</p>
                            <TabList onChange={handleChange} aria-label="lab API tabs example" variant="scrollable" scrollButtons allowScrollButtonsMobile>
                                <Tab icon={<PersonPinIcon className="icon" style={{ fontSize: 80 }} />} label="Profile" wrapped value="1" />
                                <Tab icon={<PlayIcon className="icon" />} label="Play" wrapped value="2" />
                                <Tab icon={<LearnIcon className="icon" />} label="Learn" wrapped value="3" />
                                <Tab icon={<CalendarMonthIcon className="icon" style={{ fontSize: 80 }} />} label="Appointments" wrapped value="4" />
                            </TabList>
                        </Box>
                        <TabPanel value="1">
                            <section>
                                <article>
                                    <img src={require('../../assets/images/mouseface.png')} className="mouseFace" />
                                    <Avatar src={user.picPath + "/" + user.profilePic} style={{ width: 200, height: 200 }} className="profilePic" />
                                    <h4>Change Profile Pic</h4>
                                    <form onSubmit={(e) => handleFileSubmit(e)} className="profilePicForm">
                                        <input type="file" name="myImage" onChange={(e) => handleFileChange(e)} ref={fileRef} />
                                        <button type="submit">Upload</button>
                                    </form>
                                </article>
                                <article>

                                    <dl>
                                        <dt>Your Name:</dt>
                                        <dd>{user.firstName + " " + user.lastName}</dd>
                                        <hr />
                                        <dt>Your Email Address:</dt>
                                        <dd>{user.email}</dd>
                                        <hr />
                                        <dt>Your Patient Number:</dt>
                                        <dd>{user.patientNumber}</dd>
                                        <hr />
                                        <dt>Your Username:</dt>
                                        <dd>{user.username}</dd>
                                    </dl>


                                </article>
                            </section>
                        </TabPanel>
                        <TabPanel value="2">

                            <section>
                                <article>
                                    <img src={require('../../assets/images/mouseface.png')} className="mouseFace" />
                                    <Avatar src={user.picPath + "/" + user.profilePic} style={{ width: 200, height: 200 }} className="profilePic" />
                                    <h4>Change Profile Pic</h4>
                                    <form onSubmit={(e) => handleFileSubmit(e)} className="profilePicForm">
                                        <input type="file" name="myImage" onChange={(e) => handleFileChange(e)} ref={fileRef} />
                                        <button type="submit">Upload</button>
                                    </form>
                                </article>
                                <article>
                                    <h2>Games</h2>
                                    <ul>
                                        <li><a href="#" onClick={() => handleClick({ name: 'hangman', show: true })}>Hangman</a></li>
                                        <li><a href="https://www.cbc.ca/kids/games/all/ultimate-tic-tac-toe" target="_blank">Tic Tac Toe</a></li>
                                        <li><a href="https://www.cbc.ca/kids/games/all/snakes-and-ladders" target="_blank">Snakes and Ladders</a></li>
                                        <li><a href="https://www.games.co.uk/game/words-jungle" target="_blank">Words Jungle</a></li>
                                        <li><a href="https://www.games.co.uk/game/piano-online" target="_blank">Piano Online</a></li>
                                        <li><a href="https://www.games.co.uk/game/dr-pandas-airport" target="_blank">Dr Panda's Airport</a></li>
                                        <li><a href="https://www.games.co.uk/game/12-numbers" target="_blank">12 Numbers</a></li>
                                    </ul>
                                </article>
                            </section>

                        </TabPanel>
                        <TabPanel value="3">
                            <section>
                                <article>
                                    <img src={require('../../assets/images/mouseface.png')} className="mouseFace" />
                                    <Avatar src={user.picPath + "/" + user.profilePic} style={{ width: 200, height: 200 }} className="profilePic"/>
                                    <h4>Change Profile Pic</h4>
                                    <form onSubmit={(e) => handleFileSubmit(e)} className="profilePicForm">
                                        <input type="file" name="myImage" onChange={(e) => handleFileChange(e)} ref={fileRef} />
                                        <button type="submit">Upload</button>
                                    </form>
                                </article>
                                <article>
                                    <h2>Learn</h2>
                                    <ul>
                                        <li><a href="#" onClick={() => handleClick({ learn: "types", show: true })}>Types of Doctors</a></li>
                                        <li><a href="#" onClick={() => handleClick({ learn: "kidsdreamjobs", show: true })}>Kids Dream Jobs</a></li>
                                        <li><a href="#" onClick={() => handleClick({ learn: "doctorsoffice", show: true })}>Doctor's Office</a></li>
                                    </ul>
                                </article>
                            </section>

                        </TabPanel>
                        <TabPanel value="4">
                            <section>
                                <article>
                                    <img src={require('../../assets/images/mouseface.png')} className="mouseFace" />
                                    <Avatar src={user.picPath + "/" + user.profilePic} style={{ width: 200, height: 200 }} className="profilePic" />
                                    <h4>Change Profile Pic</h4>
                                    <form onSubmit={(e) => handleFileSubmit(e)} className="profilePicForm">
                                        <input type="file" name="myImage" onChange={(e) => handleFileChange(e)} ref={fileRef} />
                                        <button type="submit">Upload</button>
                                    </form>
                                </article>
                                <article>
                                    <h2>Appointments</h2>
                                    <Appointments id={user._id} />
                                </article>
                            </section>
                        </TabPanel>
                    </TabContext>
                </Box>
            </main>

            {learnRef.current === "types" && <DoctorCheckup name="types" show={show} onClose={() => learnRef.current = null} />}
            {learnRef.current === "kidsdreamjobs" && <WantToBeDoctor name="kidsdreamjobs" show={show} onClose={() => learnRef.current = null} />}
            {learnRef.current === "doctorsoffice" && <DoctorsOffice name="doctorsoffice" show={show} onClose={() => learnRef.current = null} />}
            {gamesRef.current === 'hangman' && <Hangman open={open} onClose={() => handleClick({ show: false })} />}

        </React.Fragment>
    )
}